export default __webpack_public_path__ + "static/media/info-icon.41ec94d1.svg";